import {GameModuleBaseResponse} from './GameModuleBaseResponse';
import {GameModules} from '../GameModules';

/**
 * @class GameModuleBaseResponse - game module response type of module "base", eq: ResponseBase->modules["base"].
 */
export class GameModuleBonusRespinsResponse extends GameModuleBaseResponse {
    /**
     * @property bonusRespins - Information about bonus respins.
     */
    bonusRespins: {
        /**
         * @property remainingCount - Remaining count of bonus respins to be played.
         */
        remainingCount: number;

        /**
         * @property totalCount  - Total count of played bonus respins.
         */
        totalCount : number;

        /**
         * @property totalWin -  Sum of all bonus wins.
         */
        totalWin: number;

        /**
         * @property triggerSpinId - ID of spin which trigger bonus module.
         */
        triggerSpinId: number;

        /**
         * @property triggerModuleName - Name of module where bonus were triggered.
         */
        triggerModuleName: string;

        /**
         * @property customData - Custom screen data specific to game module. Optional.
         */
        customData?: any;
    };

    protected internalValidate(errors: Array<string>): void {
        // TODO(psulek) add check of other required properties...
    }

    public moduleName(): string {
        return GameModules.BonusRespins;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/GameModuleBonusRespinsResponse.ts
 **/